import { List } from '../objects/list';
import { Role } from '../objects/role';
import { Errors } from '../objects/errors';
import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../objects/column';

export const ADD_PREFERENCES = 'ROLE_ADD_PREFERENCES';
export const MOVE_DOWN_COLUMN = 'ROLE_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'ROLE_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'ROLE_RESET_FILTERS';
export const RESET_ROLE = 'ROLE_RESET_ROLE';
export const SET_ERRORS = 'ROLE_SET_ERRORS';
export const SET_LIMIT = 'ROLE_SET_LIMIT';
export const SET_LIST = 'ROLE_SET_LIST';
export const SET_ORDER_BY = 'ROLE_SET_ORDER_BY';
export const SET_PAGE = 'ROLE_SET_PAGE';
export const SET_PREFERENCES = 'ROLE_SET_PREFERENCES';
export const SET_ROLE = 'ROLE_SET_ROLE';
export const SET_ROLE_DELETE = 'ROLE_SET_ROLE_DELETE';
export const SET_RUNNING = 'ROLE_SET_RUNNING';
export const SET_SEARCH = 'ROLE_SET_SEARCH';
export const TOGGLE_COLUMN = 'ROLE_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'ROLE_TOGGLE_CREATE';
export const TOGGLE_FILTERS = 'ROLE_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'ROLE_TOGGLE_REFRESH';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'ROLE_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'ROLE_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'ROLE_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'ROLE_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'ROLE_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'ROLE_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'ROLE_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'ROLE_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_IS_ADMIN = 'ROLE_UPDATE_IS_ADMIN';
export const UPDATE_DOCUMENTATION_ONLY = 'ROLE_UPDATE_DOCUMENTATION_ONLY';
export const UPDATE_DOCUMENTATION_ACCESS = "ROLE_UPDATE_DOCUMENTATION_ACCESS";
export const UPDATE_NAME = 'ROLE_UPDATE_NAME';
export const UPDATE_NAME_LOCALE = 'ROLE_UPDATE_NAME_LOCALE';
export const SET_COLUMNS = 'ROLE_SET_COLUMNS';
export const RESIZE_COLUMN = 'ROLE_RESIZE_COLUMN';

interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetRoleAction {
    type: typeof RESET_ROLE
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRoleAction {
    type: typeof SET_ROLE,
    payload: Role
}

interface SetRoleDeleteAction {
    type: typeof SET_ROLE_DELETE,
    payload: null | false | Role
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateIsAdminAction {
    type: typeof UPDATE_IS_ADMIN,
    payload: boolean,
}

interface UpdateDocumentationOnly {
    type: typeof UPDATE_DOCUMENTATION_ONLY,
    payload: boolean,
}

interface UpdateDocumentationAccess {
    type: typeof UPDATE_DOCUMENTATION_ACCESS,
    payload: boolean,
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdateNameLocaleAction {
    type: typeof UPDATE_NAME_LOCALE,
    payload: {
        id: number,
        value: string
    }
}

export type RoleActionTypes =
    SetColumnsAction |
    ResizeColumnAction |
    AddPreferencesAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetRoleAction |
    SetErrorsAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRoleAction |
    SetRoleDeleteAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleFiltersAction |
    ToggleNewAction |
    ToggleRefreshAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateIsAdminAction |
    UpdateDocumentationOnly |
    UpdateDocumentationAccess |
    UpdateNameAction |
    UpdateNameLocaleAction;